import { parse, stringifyUrl } from 'query-string';

export function useUrlData(request, { ...rest }) {
  const { location, history } = window;

  const search = location.search;
  const hash = location.hash;

  const query = parse(search, {
    arrayFormat: 'separator',
    arrayFormatSeparator: '|',
  });

  function updateSearch(newSearch) {
    const stringified = stringifyUrl({
      url: location.pathname,
      query: newSearch,
      fragmentIdentifier: hash.replace('#', ''),
    });

    // console.log(`Stringified: ${stringified}`);

    history.replaceState(null, null, stringified);
  }

  return [query, updateSearch];
}
